import React from 'react';
import {
  IconButton,
  useTheme,
  useMediaQuery,
  Drawer,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SideNav from './SideNav';

const CollapsibleSidebar = ({ open, onToggle, variant = 'persistent' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const drawerWidth = open ? 280 : 80;

  const handleToggle = () => {
    onToggle(!open);
  };

  const ToggleButton = () => (
    <IconButton
      onClick={handleToggle}
      sx={{
        position: 'absolute',
        right: -16,
        top: 80,
        width: 32,
        height: 32,
        backgroundColor: '#ffffff',
        border: '2px solid #E9E9F2',
        borderRadius: '50%',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        zIndex: 1000,
        '&:hover': {
          backgroundColor: '#FAFAFD',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        },
      }}
    >
      {open ? (
        <ChevronLeftIcon sx={{ fontSize: 16, color: '#7B7A92' }} />
      ) : (
        <ChevronRightIcon sx={{ fontSize: 16, color: '#7B7A92' }} />
      )}
    </IconButton>
  );

  return (
    <>
      <Drawer
        variant={variant}
        open={open}
        onClose={() => onToggle(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            border: 'none',
            backgroundColor: '#ffffff',
            boxShadow: '0 0 20px rgba(0,0,0,0.1)',
            transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            overflowX: 'hidden',
            position: 'relative',
          },
        }}
      >
        <SideNav open={open} onClose={() => onToggle(false)} variant={variant} />
        {!isMobile && <ToggleButton />}
      </Drawer>
    </>
  );
};

export default CollapsibleSidebar;
